export enum ActionState {
  SUCCESS = 'SUCCESS',
  READY = 'READY',
  LOADING = 'LOADING',
  FAILED = 'FAILED',
}
